import { render, staticRenderFns } from "./create-patient-service-unpacked.vue?vue&type=template&id=722a5f86&"
import script from "./create-patient-service-unpacked.vue?vue&type=script&lang=js&"
export * from "./create-patient-service-unpacked.vue?vue&type=script&lang=js&"
import style0 from "./create-patient-service-unpacked.vue?vue&type=style&index=0&id=722a5f86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports